import { createContext } from 'react';

/** Shared context for sidebar collapsed state. */
export const SidebarCollapsedContext = createContext(false);
